import React, { useRef, useState, useEffect } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Modal } from "react-bootstrap";

const CropperModal = ({
  show,
  image,
  handleClose,
  sendCropedDataToParent,
  aspectRation,
  croppedSize,
}) => {
  const cropperRef = useRef(null);
  const [isTransparent, setIsTransparent] = useState(false);

  // Check if uploaded image has transparency
  useEffect(() => {
    if (!image) return;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, img.width, img.height).data;

      // If any pixel alpha < 255 → transparency exists
      for (let i = 3; i < imageData.length; i += 4) {
        if (imageData[i] < 255) {
          setIsTransparent(true);
          return;
        }
      }
      setIsTransparent(false);
    };
    img.src = image;
  }, [image]);

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      const canvas = cropperRef.current?.cropper.getCroppedCanvas(croppedSize);

      let croppedFile;
      if (isTransparent) {
        // Keep transparency (PNG)
        croppedFile = canvas.toDataURL("image/png");
      } else {
        // Use JPEG for non-transparent (smaller file size)
        croppedFile = canvas.toDataURL("image/jpeg", 0.7);
      }

      sendCropedDataToParent(croppedFile);
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      centered
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      dialogClassName="custom-modal"
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title className="fw-bold">Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Cropper
          src={image}
          style={{ height: 400, width: "100%" }}
          initialAspectRatio={1}
          guides={false}
          autoCropArea={aspectRation}
          ref={cropperRef}
          scalable={false}
          // zoomable={false}
          background={true}

  zoomable={true}     // allow zoom for QR codes
  // movable={true} 
        />

        <div className="btn-wrapper d-flex flex-wrap justify-content-center gap-3 mt-4">
          <button
            type="submit"
            className="btn btn-custom"
            onClick={getCropData}
          >
            Crop Image
          </button>
          <button
            type="reset"
            className="btn btn-custom"
            onClick={handleClose}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CropperModal;
